module.exports = __webpack_public_path__ + "img/idCardBack.80eb8455.png";